export default __webpack_public_path__ + "static/media/Budget_meeting_30112022.06270755.pdf";